import { render, staticRenderFns } from "./BatteryPerformanceChart.vue?vue&type=template&id=f49ce282&"
import script from "./BatteryPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./BatteryPerformanceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports